webpackJsonp([107797244422894],{

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(94);

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var settle = __webpack_require__(100);
	var buildURL = __webpack_require__(102);
	var parseHeaders = __webpack_require__(108);
	var isURLSameOrigin = __webpack_require__(106);
	var createError = __webpack_require__(55);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(104);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var bind = __webpack_require__(56);
	var Axios = __webpack_require__(96);
	var defaults = __webpack_require__(31);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(53);
	axios.CancelToken = __webpack_require__(95);
	axios.isCancel = __webpack_require__(54);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(109);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(53);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(31);
	var utils = __webpack_require__(5);
	var InterceptorManager = __webpack_require__(97);
	var dispatchRequest = __webpack_require__(98);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(99);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	var transformData = __webpack_require__(101);
	var isCancel = __webpack_require__(54);
	var defaults = __webpack_require__(31);
	var isAbsoluteURL = __webpack_require__(105);
	var combineURLs = __webpack_require__(103);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(55);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(5);
	var normalizeHeaderName = __webpack_require__(107);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(52);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(52);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(5);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(56);
	var isBuffer = __webpack_require__(146);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
	function testPassiveEventListeners() {
	  if (!CAN_USE_DOM) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      // eslint-disable-next-line getter-return
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    var noop = function noop() {};
	    window.addEventListener('testPassiveEventSupport', noop, opts);
	    window.removeEventListener('testPassiveEventSupport', noop, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!canUsePassiveEventListeners()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}
	
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	function TargetEventHandlers(target) {
	  this.target = target;
	  this.events = {};
	}
	
	TargetEventHandlers.prototype.getEventHandlers = function () {
	  function getEventHandlers(eventName, options) {
	    var key = String(eventName) + ' ' + String(eventOptionsKey(options));
	
	    if (!this.events[key]) {
	      this.events[key] = {
	        handlers: [],
	        handleEvent: undefined
	      };
	      this.events[key].nextHandlers = this.events[key].handlers;
	    }
	
	    return this.events[key];
	  }
	
	  return getEventHandlers;
	}();
	
	TargetEventHandlers.prototype.handleEvent = function () {
	  function handleEvent(eventName, options, event) {
	    var eventHandlers = this.getEventHandlers(eventName, options);
	    eventHandlers.handlers = eventHandlers.nextHandlers;
	    eventHandlers.handlers.forEach(function (handler) {
	      if (handler) {
	        // We need to check for presence here because a handler function may
	        // cause later handlers to get removed. This can happen if you for
	        // instance have a waypoint that unmounts another waypoint as part of an
	        // onEnter/onLeave handler.
	        handler(event);
	      }
	    });
	  }
	
	  return handleEvent;
	}();
	
	TargetEventHandlers.prototype.add = function () {
	  function add(eventName, listener, options) {
	    var _this = this;
	
	    // options has already been normalized at this point.
	    var eventHandlers = this.getEventHandlers(eventName, options);
	
	    ensureCanMutateNextEventHandlers(eventHandlers);
	
	    if (eventHandlers.nextHandlers.length === 0) {
	      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	    }
	
	    eventHandlers.nextHandlers.push(listener);
	
	    var isSubscribed = true;
	    var unsubscribe = function () {
	      function unsubscribe() {
	        if (!isSubscribed) {
	          return;
	        }
	
	        isSubscribed = false;
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	        var index = eventHandlers.nextHandlers.indexOf(listener);
	        eventHandlers.nextHandlers.splice(index, 1);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          // All event handlers have been removed, so we want to remove the event
	          // listener from the target node.
	
	          if (_this.target) {
	            // There can be a race condition where the target may no longer exist
	            // when this function is called, e.g. when a React component is
	            // unmounting. Guarding against this prevents the following error:
	            //
	            //   Cannot read property 'removeEventListener' of undefined
	            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	          }
	
	          eventHandlers.handleEvent = undefined;
	        }
	      }
	
	      return unsubscribe;
	    }();
	    return unsubscribe;
	  }
	
	  return add;
	}();
	
	var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	// eslint-disable-next-line import/prefer-default-export
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
	  }
	  var normalizedEventOptions = normalizeEventOptions(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	exports.addEventListener = addEventListener;


/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(70);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(2));
	var consolidatedEvents = __webpack_require__(60);
	var PropTypes = _interopDefault(__webpack_require__(3));
	var reactIs = __webpack_require__(71);
	
	/**
	 * Attempts to parse the offset provided as a prop as a percentage. For
	 * instance, if the component has been provided with the string "20%" as
	 * a value of one of the offset props. If the value matches, then it returns
	 * a numeric version of the prop. For instance, "20%" would become `0.2`.
	 * If `str` isn't a percentage, then `undefined` will be returned.
	 *
	 * @param {string} str The value of an offset prop to be converted to a
	 *   number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was not a percentage.
	 */
	function parseOffsetAsPercentage(str) {
	  if (str.slice(-1) === '%') {
	    return parseFloat(str.slice(0, -1)) / 100;
	  }
	}
	
	/**
	 * Attempts to parse the offset provided as a prop as a pixel value. If
	 * parsing fails, then `undefined` is returned. Three examples of values that
	 * will be successfully parsed are:
	 * `20`
	 * "20px"
	 * "20"
	 *
	 * @param {string|number} str A string of the form "{number}" or "{number}px",
	 *   or just a number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was neither a number nor string ending in "px".
	 */
	function parseOffsetAsPixels(str) {
	  if (!isNaN(parseFloat(str)) && isFinite(str)) {
	    return parseFloat(str);
	  } else if (str.slice(-2) === 'px') {
	    return parseFloat(str.slice(0, -2));
	  }
	}
	
	/**
	 * @param {string|number} offset
	 * @param {number} contextHeight
	 * @return {number} A number representing `offset` converted into pixels.
	 */
	function computeOffsetPixels(offset, contextHeight) {
	  var pixelOffset = parseOffsetAsPixels(offset);
	
	  if (typeof pixelOffset === 'number') {
	    return pixelOffset;
	  }
	
	  var percentOffset = parseOffsetAsPercentage(offset);
	  if (typeof percentOffset === 'number') {
	    return percentOffset * contextHeight;
	  }
	}
	
	var constants = {
	  above: 'above',
	  inside: 'inside',
	  below: 'below',
	  invisible: 'invisible'
	};
	
	function debugLog() {
	  if (false) {
	    console.log(arguments); // eslint-disable-line no-console
	  }
	}
	
	var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if more that one child was provided to "children"
	 *
	 * @param {?React.element} children
	 * @return {undefined}
	 */
	function ensureChildrenIsValid(children) {
	  if (children) {
	    try {
	      React.Children.only(children);
	    } catch (e) {
	      throw new Error(errorMessage);
	    }
	  }
	}
	
	/**
	 * When an element's type is a string, it represents a DOM node with that tag name
	 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
	 *
	 * @param {React.element} Component
	 * @return {bool} Whether the component is a DOM Element
	 */
	function isDOMElement(Component) {
	  return typeof Component.type === 'string';
	}
	
	var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
	 *
	 * @param {?React.element} children
	 * @param {?HTMLElement} ref
	 * @return {undefined}
	 */
	function ensureRefIsProvidedByChild(children, ref) {
	  if (children && !isDOMElement(children) && !ref) {
	    throw new Error(errorMessage$1);
	  }
	}
	
	/**
	 * @param {object} bounds An object with bounds data for the waypoint and
	 *   scrollable parent
	 * @return {string} The current position of the waypoint in relation to the
	 *   visible portion of the scrollable parent. One of `constants.above`,
	 *   `constants.below`, or `constants.inside`.
	 */
	function getCurrentPosition(bounds) {
	  if (bounds.viewportBottom - bounds.viewportTop === 0) {
	    return constants.invisible;
	  }
	
	  // top is within the viewport
	  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // bottom is within the viewport
	  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // top is above the viewport and bottom is below the viewport
	  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
	    return constants.inside;
	  }
	
	  if (bounds.viewportBottom < bounds.waypointTop) {
	    return constants.below;
	  }
	
	  if (bounds.waypointTop < bounds.viewportTop) {
	    return constants.above;
	  }
	
	  return constants.invisible;
	}
	
	var timeout = void 0;
	var timeoutQueue = [];
	
	function onNextTick(cb) {
	  timeoutQueue.push(cb);
	
	  if (!timeout) {
	    timeout = setTimeout(function () {
	      timeout = null;
	
	      // Drain the timeoutQueue
	      var item = void 0;
	      // eslint-disable-next-line no-cond-assign
	      while (item = timeoutQueue.shift()) {
	        item();
	      }
	    }, 0);
	  }
	
	  var isSubscribed = true;
	
	  return function () {
	    function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      var index = timeoutQueue.indexOf(cb);
	      if (index === -1) {
	        return;
	      }
	
	      timeoutQueue.splice(index, 1);
	
	      if (!timeoutQueue.length && timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	    }
	
	    return unsubscribe;
	  }();
	}
	
	function resolveScrollableAncestorProp(scrollableAncestor) {
	  // When Waypoint is rendered on the server, `window` is not available.
	  // To make Waypoint easier to work with, we allow this to be specified in
	  // string form and safely convert to `window` here.
	  if (scrollableAncestor === 'window') {
	    return global.window;
	  }
	
	  return scrollableAncestor;
	}
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  topOffset: '0px',
	  bottomOffset: '0px',
	  horizontal: false,
	  onEnter: function () {
	    function onEnter() {}
	
	    return onEnter;
	  }(),
	  onLeave: function () {
	    function onLeave() {}
	
	    return onLeave;
	  }(),
	  onPositionChange: function () {
	    function onPositionChange() {}
	
	    return onPositionChange;
	  }(),
	
	  fireOnRapidScroll: true
	};
	
	// React.PureComponent was added in React 15.3.0
	var BaseClass = typeof React.PureComponent !== 'undefined' ? React.PureComponent : React.Component;
	
	// Calls a function when you scroll to the element.
	
	var Waypoint = function (_BaseClass) {
	  _inherits(Waypoint, _BaseClass);
	
	  function Waypoint(props) {
	    _classCallCheck(this, Waypoint);
	
	    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));
	
	    _this.refElement = function (e) {
	      return _this._ref = e;
	    };
	    return _this;
	  }
	
	  _createClass(Waypoint, [{
	    key: 'componentWillMount',
	    value: function () {
	      function componentWillMount() {
	        ensureChildrenIsValid(this.props.children);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        // this._ref may occasionally not be set at this time. To help ensure that
	        // this works smoothly and to avoid layout thrashing, we want to delay the
	        // initial execution until the next tick.
	        this.cancelOnNextTick = onNextTick(function () {
	          _this2.cancelOnNextTick = null;
	
	          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
	          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);
	
	          _this2._handleScroll = _this2._handleScroll.bind(_this2);
	          _this2.scrollableAncestor = _this2._findScrollableAncestor();
	
	          if (false) {
	            debugLog('scrollableAncestor', _this2.scrollableAncestor);
	          }
	
	          _this2.scrollEventListenerUnsubscribe = consolidatedEvents.addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });
	
	          _this2.resizeEventListenerUnsubscribe = consolidatedEvents.addEventListener(window, 'resize', _this2._handleScroll, { passive: true });
	
	          _this2._handleScroll(null);
	        });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(newProps) {
	        ensureChildrenIsValid(newProps.children);
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        var _this3 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (!this.scrollableAncestor) {
	          // The Waypoint has not yet initialized.
	          return;
	        }
	
	        // The element may have moved, so we need to recompute its position on the
	        // page. This happens via handleScroll in a way that forces layout to be
	        // computed.
	        //
	        // We want this to be deferred to avoid forcing layout during render, which
	        // causes layout thrashing. And, if we already have this work enqueued, we
	        // can just wait for that to happen instead of enqueueing again.
	        if (this.cancelOnNextTick) {
	          return;
	        }
	
	        this.cancelOnNextTick = onNextTick(function () {
	          _this3.cancelOnNextTick = null;
	          _this3._handleScroll(null);
	        });
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (this.scrollEventListenerUnsubscribe) {
	          this.scrollEventListenerUnsubscribe();
	        }
	        if (this.resizeEventListenerUnsubscribe) {
	          this.resizeEventListenerUnsubscribe();
	        }
	
	        if (this.cancelOnNextTick) {
	          this.cancelOnNextTick();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	
	    /**
	     * Traverses up the DOM to find an ancestor container which has an overflow
	     * style that allows for scrolling.
	     *
	     * @return {Object} the closest ancestor element with an overflow style that
	     *   allows for scrolling. If none is found, the `window` object is returned
	     *   as a fallback.
	     */
	
	  }, {
	    key: '_findScrollableAncestor',
	    value: function () {
	      function _findScrollableAncestor() {
	        var _props = this.props,
	            horizontal = _props.horizontal,
	            scrollableAncestor = _props.scrollableAncestor;
	
	
	        if (scrollableAncestor) {
	          return resolveScrollableAncestorProp(scrollableAncestor);
	        }
	
	        var node = this._ref;
	
	        while (node.parentNode) {
	          node = node.parentNode;
	
	          if (node === document.body) {
	            // We've reached all the way to the root node.
	            return window;
	          }
	
	          var style = window.getComputedStyle(node);
	          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
	          var overflow = overflowDirec || style.getPropertyValue('overflow');
	
	          if (overflow === 'auto' || overflow === 'scroll') {
	            return node;
	          }
	        }
	
	        // A scrollable ancestor element was not found, which means that we need to
	        // do stuff on window.
	        return window;
	      }
	
	      return _findScrollableAncestor;
	    }()
	
	    /**
	     * @param {Object} event the native scroll event coming from the scrollable
	     *   ancestor, or resize event coming from the window. Will be undefined if
	     *   called by a React lifecyle method
	     */
	
	  }, {
	    key: '_handleScroll',
	    value: function () {
	      function _handleScroll(event) {
	        if (!this._ref) {
	          // There's a chance we end up here after the component has been unmounted.
	          return;
	        }
	
	        var bounds = this._getBounds();
	        var currentPosition = getCurrentPosition(bounds);
	        var previousPosition = this._previousPosition;
	
	        if (false) {
	          debugLog('currentPosition', currentPosition);
	          debugLog('previousPosition', previousPosition);
	        }
	
	        // Save previous position as early as possible to prevent cycles
	        this._previousPosition = currentPosition;
	
	        if (previousPosition === currentPosition) {
	          // No change since last trigger
	          return;
	        }
	
	        var callbackArg = {
	          currentPosition: currentPosition,
	          previousPosition: previousPosition,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        };
	        this.props.onPositionChange.call(this, callbackArg);
	
	        if (currentPosition === constants.inside) {
	          this.props.onEnter.call(this, callbackArg);
	        } else if (previousPosition === constants.inside) {
	          this.props.onLeave.call(this, callbackArg);
	        }
	
	        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
	        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;
	
	        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
	          // If the scroll event isn't fired often enough to occur while the
	          // waypoint was visible, we trigger both callbacks anyway.
	          this.props.onEnter.call(this, {
	            currentPosition: constants.inside,
	            previousPosition: previousPosition,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	          this.props.onLeave.call(this, {
	            currentPosition: currentPosition,
	            previousPosition: constants.inside,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	        }
	      }
	
	      return _handleScroll;
	    }()
	  }, {
	    key: '_getBounds',
	    value: function () {
	      function _getBounds() {
	        var horizontal = this.props.horizontal;
	
	        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
	            left = _ref$getBoundingClien.left,
	            top = _ref$getBoundingClien.top,
	            right = _ref$getBoundingClien.right,
	            bottom = _ref$getBoundingClien.bottom;
	
	        var waypointTop = horizontal ? left : top;
	        var waypointBottom = horizontal ? right : bottom;
	
	        var contextHeight = void 0;
	        var contextScrollTop = void 0;
	        if (this.scrollableAncestor === window) {
	          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
	          contextScrollTop = 0;
	        } else {
	          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
	          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
	        }
	
	        if (false) {
	          debugLog('waypoint top', waypointTop);
	          debugLog('waypoint bottom', waypointBottom);
	          debugLog('scrollableAncestor height', contextHeight);
	          debugLog('scrollableAncestor scrollTop', contextScrollTop);
	        }
	
	        var _props2 = this.props,
	            bottomOffset = _props2.bottomOffset,
	            topOffset = _props2.topOffset;
	
	        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
	        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
	        var contextBottom = contextScrollTop + contextHeight;
	
	        return {
	          waypointTop: waypointTop,
	          waypointBottom: waypointBottom,
	          viewportTop: contextScrollTop + topOffsetPx,
	          viewportBottom: contextBottom - bottomOffsetPx
	        };
	      }
	
	      return _getBounds;
	    }()
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this4 = this;
	
	        var children = this.props.children;
	
	
	        if (!children) {
	          // We need an element that we can locate in the DOM to determine where it is
	          // rendered relative to the top of its context.
	          return React.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
	        }
	
	        if (isDOMElement(children) || reactIs.isForwardRef(children.type)) {
	          var ref = function () {
	            function ref(node) {
	              _this4.refElement(node);
	              if (children.ref) {
	                if (typeof children.ref === 'function') {
	                  children.ref(node);
	                } else {
	                  children.ref.current = node;
	                }
	              }
	            }
	
	            return ref;
	          }();
	
	          return React.cloneElement(children, { ref: ref });
	        }
	
	        return React.cloneElement(children, { innerRef: this.refElement });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Waypoint;
	}(BaseClass);
	
	
	Waypoint.propTypes = {
	  children: PropTypes.node,
	  debug: PropTypes.bool,
	  onEnter: PropTypes.func,
	  onLeave: PropTypes.func,
	  onPositionChange: PropTypes.func,
	  fireOnRapidScroll: PropTypes.bool,
	  scrollableAncestor: PropTypes.any,
	  horizontal: PropTypes.bool,
	
	  // `topOffset` can either be a number, in which case its a distance from the
	  // top of the container in pixels, or a string value. Valid string values are
	  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
	  // as a percentage of the height of the containing element.
	  // For instance, if you pass "-20%", and the containing element is 100px tall,
	  // then the waypoint will be triggered when it has been scrolled 20px beyond
	  // the top of the containing element.
	  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	
	  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
	  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	Waypoint.above = constants.above;
	Waypoint.below = constants.below;
	Waypoint.inside = constants.inside;
	Waypoint.invisible = constants.invisible;
	Waypoint.getWindow = function () {
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	};
	Waypoint.defaultProps = defaultProps;
	Waypoint.displayName = 'Waypoint';
	
	module.exports = Waypoint;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fragment = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactWaypoint = __webpack_require__(73);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _jsCookie = __webpack_require__(194);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _axios = __webpack_require__(93);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lazyImage = __webpack_require__(12);
	
	var _headerSpacer = __webpack_require__(20);
	
	var _headerSpacer2 = _interopRequireDefault(_headerSpacer);
	
	var _excerptList = __webpack_require__(76);
	
	var _excerptList2 = _interopRequireDefault(_excerptList);
	
	var _excerpt = __webpack_require__(75);
	
	var _excerpt2 = _interopRequireDefault(_excerpt);
	
	var _social = __webpack_require__(160);
	
	var _social2 = _interopRequireDefault(_social);
	
	var _navigation = __webpack_require__(24);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _linkBuilder = __webpack_require__(21);
	
	var _linkBuilder2 = _interopRequireDefault(_linkBuilder);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _postModule = __webpack_require__(88);
	
	var _postModule2 = _interopRequireDefault(_postModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var postTileLarge = _postModule2.default.postTileLarge,
	    postDateLarge = _postModule2.default.postDateLarge,
	    postCategoriesLarge = _postModule2.default.postCategoriesLarge,
	    postSingleDetails = _postModule2.default.postSingleDetails,
	    postSingleContent = _postModule2.default.postSingleContent,
	    postSingleArchives = _postModule2.default.postSingleArchives,
	    postSingleContainer = _postModule2.default.postSingleContainer,
	    postSingleLayout = _postModule2.default.postSingleLayout,
	    postSingleArchiveTitle = _postModule2.default.postSingleArchiveTitle,
	    postSingleArchiveList = _postModule2.default.postSingleArchiveList,
	    postSingleArchiveItem = _postModule2.default.postSingleArchiveItem,
	    postSingleSeeMore = _postModule2.default.postSingleSeeMore,
	    postSingleItem_text = _postModule2.default.postSingleItem_text;
	
	
	function intersperse(arr, sep) {
	  if (arr.length === 0) {
	    return [];
	  }
	
	  return arr.slice(1).reduce(function (xs, x, i) {
	    return xs.concat([sep, x]);
	  }, [arr[0]]);
	}
	
	var FixedSocial = function (_React$Component) {
	  _inherits(FixedSocial, _React$Component);
	
	  function FixedSocial(props) {
	    _classCallCheck(this, FixedSocial);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      fixedSocial: false,
	      left: 0,
	      show: false
	    };
	    _this.ref = null;
	
	    _this.socialPositionChanged = _this.socialPositionChanged.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.onResize = _this.onResize.bind(_this);
	    _this.onLoad = _this.onLoad.bind(_this);
	    return _this;
	  }
	
	  FixedSocial.prototype.socialPositionChanged = function socialPositionChanged(e) {
	    var fixedSocial = e.currentPosition === 'below';
	    if (fixedSocial !== this.state.fixedSocial) {
	      this.setState(function (state) {
	        return _extends({}, state, {
	          fixedSocial: fixedSocial
	        });
	      });
	    }
	  };
	
	  FixedSocial.prototype.onResize = function onResize() {
	    var bbox = this.ref.getBoundingClientRect();
	    var left = bbox.left;
	    if (left !== this.state.left) {
	      this.setState(function (state) {
	        return _extends({}, state, {
	          left: left
	        });
	      });
	    }
	  };
	
	  FixedSocial.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('resize', this.onResize);
	    window.addEventListener('load', this.onLoad);
	    if (document.readyState === 'complete') {
	      this.onLoad();
	    } else {
	      this.onResize();
	    }
	  };
	
	  FixedSocial.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.ref = null;
	    window.removeEventListener('resize', this.onResize);
	    window.removeEventListener('load', this.onLoad);
	  };
	
	  FixedSocial.prototype.setRef = function setRef(ref) {
	    this.ref = ref;
	  };
	
	  FixedSocial.prototype.onLoad = function onLoad() {
	    this.setState(function (state) {
	      return _extends({}, state, { show: true });
	    });
	    this.onResize();
	  };
	
	  FixedSocial.prototype.render = function render() {
	    var _state = this.state,
	        fixedSocial = _state.fixedSocial,
	        left = _state.left,
	        show = _state.show;
	
	
	    var style = {};
	
	    if (fixedSocial) {
	      style = {
	        position: 'fixed',
	        left: left,
	        bottom: 20
	      };
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _postModule2.default.postSingleSocial },
	      _react2.default.createElement(
	        'div',
	        { ref: this.setRef },
	        (show || !fixedSocial) && _react2.default.createElement(
	          'div',
	          { style: style },
	          _react2.default.createElement(_social2.default, { url: this.props.url })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _postModule2.default.postSingleSocialBreakPoint },
	        _react2.default.createElement(_reactWaypoint2.default, { onPositionChange: this.socialPositionChanged })
	      )
	    );
	  };
	
	  return FixedSocial;
	}(_react2.default.Component);
	
	var ArhiveList = function (_React$PureComponent) {
	  _inherits(ArhiveList, _React$PureComponent);
	
	  function ArhiveList(props) {
	    _classCallCheck(this, ArhiveList);
	
	    var _this2 = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this2.toggleExpand = _this2.toggleExpand.bind(_this2);
	    _this2.state = {
	      expanded: false
	    };
	    return _this2;
	  }
	
	  ArhiveList.prototype.toggleExpand = function toggleExpand() {
	    this.setState(function (state) {
	      return _extends({}, state, {
	        expanded: !state.expanded
	      });
	    });
	  };
	
	  ArhiveList.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        items = _props.items,
	        _props$forceExpanded = _props.forceExpanded,
	        forceExpanded = _props$forceExpanded === undefined ? false : _props$forceExpanded;
	    var expanded = this.state.expanded;
	
	
	    var treshhold = 3;
	    var renderShowMore = !forceExpanded && items.length > treshhold + 1;
	    var renderItems = expanded || !renderShowMore ? items : items.slice(0, 3);
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'h3',
	        { className: postSingleArchiveTitle },
	        label
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: postSingleArchiveList },
	        items.map(function (item, index) {
	          return _react2.default.createElement(
	            'li',
	            {
	              className: expanded || !renderShowMore || index < treshhold ? _postModule2.default.postSingleArchiveItemVisible : _postModule2.default.postSingleArchiveItemHidden,
	              key: item.slug
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: item.link },
	              item.label,
	              ' (',
	              item.count,
	              ')'
	            )
	          );
	        }),
	        renderShowMore && _react2.default.createElement(
	          'li',
	          { className: _postModule2.default.postSingleArchiveItemShowMoreOrLess },
	          _react2.default.createElement(
	            'span',
	            {
	              onClick: this.toggleExpand,
	              className: _postModule2.default.postSingleArchiveItemMoreOrLess
	            },
	            (0, _stringTranslation.translate)(expanded ? 'showless' : 'showmore')
	          )
	        )
	      )
	    );
	  };
	
	  return ArhiveList;
	}(_react2.default.PureComponent);
	
	var SinglePost = function (_React$PureComponent2) {
	  _inherits(SinglePost, _React$PureComponent2);
	
	  function SinglePost(props) {
	    _classCallCheck(this, SinglePost);
	
	    var _this3 = _possibleConstructorReturn(this, _React$PureComponent2.call(this, props));
	
	    var article = props.data.article;
	
	    _this3.article = _extends({}, article, {
	      url: (0, _linkBuilder2.default)({
	        type: 'post',
	        lang: article.lang,
	        slug: article.slug,
	        absolute: true
	      }),
	      categories: article.categories.map(function (cat) {
	        return _globalState2.default.state.articleCategories.find(function (gcat) {
	          return gcat.slug === cat.slug;
	        });
	      })
	    });
	
	    _this3.monthlyArchives = _this3.props.data.monthlyArchives ? _this3.props.data.monthlyArchives.edges.map(function (edge) {
	      return _extends({}, edge.node, {
	        label: (0, _stringTranslation.translate)('months')[edge.node.month - 1] + ' ' + edge.node.year
	      });
	    }).sort(function (a, b) {
	      var year_a = parseInt(a.year);
	      var year_b = parseInt(b.year);
	
	      return -(year_a !== year_b ? year_a - year_b : a.month - b.month);
	    }) : [];
	
	    // this.monthlyArchives = [
	    //   ...this.monthlyArchives,
	    //   ...this.monthlyArchives,
	    //   ...this.monthlyArchives,
	    //   ...this.monthlyArchives,
	    //   ...this.monthlyArchives,
	    //   ...this.monthlyArchives,
	    // ]
	    _this3.hasRead = _this3.hasRead.bind(_this3);
	
	    _this3.id = _this3.props.data.article.wordpress_id;
	    return _this3;
	  }
	
	  SinglePost.prototype.readCookie = function readCookie() {
	    this.reportedRead = false;
	    var cookie = _jsCookie2.default.get('readStatus');
	
	    if (cookie) {
	      var c = JSON.parse(cookie);
	      if (typeof c === 'object') {
	        this.readStatus = c;
	        this.reportedRead = !!this.readStatus[this.id];
	        return;
	      }
	    }
	    this.readStatus = {};
	  };
	
	  SinglePost.prototype.componentDidMount = function componentDidMount() {
	    this.readCookie();
	  };
	
	  SinglePost.prototype.hasRead = function hasRead() {
	    var _this4 = this;
	
	    if (!this.reportedRead) {
	      var url = 'http://admin.brandglow.pl/wp-admin/admin-ajax.php';
	
	      _axios2.default.get(url, {
	        params: {
	          action: 'has_read',
	          id: this.id
	        }
	      }).then(function (response) {
	        return response.data;
	      }).then(function (data) {
	        if (data.success) {
	          _this4.reportedRead = true;
	          _this4.readStatus[_this4.id] = 1;
	          _jsCookie2.default.set('readStatus', _this4.readStatus);
	        }
	      }).catch(function (error) {
	        console.log('error', error);
	      });
	    }
	  };
	
	  SinglePost.prototype.renderItem = function renderItem(item, index) {
	    var elem = null,
	        type = null;
	
	    if (item.__typename === 'WordPressAcf_post_layout_text' && item.text) {
	      type = 'text';
	      elem = _react2.default.createElement('div', {
	        className: 'styled-content',
	        dangerouslySetInnerHTML: {
	          __html: item.text
	        }
	      });
	    } else if (item.__typename === 'WordPressAcf_post_layout_image' && item.respImage
	    // item.image.localFile.childImageSharp
	    ) {
	        type = 'image';
	        elem = _react2.default.createElement(_lazyImage.Image, { sizes: item.respImage });
	      }
	
	    return elem ? _react2.default.createElement(
	      'div',
	      { className: _postModule2.default['postSingleItem_' + type], key: 'item_' + index },
	      elem
	    ) : null;
	  };
	
	  SinglePost.prototype.render = function render() {
	    var _this5 = this;
	
	    var article = this.article;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: postSingleContainer },
	        article.respFeaturedImage && _react2.default.createElement(_lazyImage.Image, { sizes: article.respFeaturedImage }),
	        _react2.default.createElement(
	          'div',
	          { className: postSingleLayout },
	          _react2.default.createElement(
	            'div',
	            { className: postSingleDetails },
	            _react2.default.createElement('h1', {
	              className: postTileLarge,
	              dangerouslySetInnerHTML: {
	                __html: article.title
	              }
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: postDateLarge },
	              article.formattedDate
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: postCategoriesLarge },
	              (0, _stringTranslation.translate)('category'),
	              ':',
	              ' ',
	              intersperse(article.categories.map(function (category) {
	                return _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { key: category.label, to: category.link },
	                  category.label
	                );
	              }), ', ')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: postSingleContent },
	            article.acf.post_layout_post && article.acf.post_layout_post.map(this.renderItem),
	            _react2.default.createElement(_reactWaypoint2.default, { onEnter: this.hasRead })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: postSingleArchives },
	            _react2.default.createElement(ArhiveList, {
	              label: (0, _stringTranslation.translate)('categories'),
	              forceExpanded: true,
	              items: _globalState2.default.state.articleCategories.filter(function (category) {
	                return category.lang === _this5.props.lang;
	              })
	            }),
	            this.monthlyArchives.length > 0 && _react2.default.createElement(ArhiveList, {
	              label: (0, _stringTranslation.translate)('archive'),
	              items: this.monthlyArchives
	            })
	          )
	        ),
	        _react2.default.createElement(FixedSocial, { url: article.url }),
	        this.props.data.relatedArchives && _react2.default.createElement(
	          'div',
	          { className: postSingleSeeMore },
	          'Zobacz r\xF3wnie\u017C:'
	        ),
	        this.props.data.relatedArchives && _react2.default.createElement(
	          _excerptList2.default,
	          null,
	          this.props.data.relatedArchives.edges.map(function (edge) {
	            return _react2.default.createElement(_excerpt2.default, { key: edge.node.slug, data: edge.node });
	          })
	        )
	      ),
	      _react2.default.createElement(_navigation2.default, null)
	    );
	  };
	
	  return SinglePost;
	}(_react2.default.PureComponent);
	
	exports.default = SinglePost;
	var fragment = exports.fragment = '** extracted graphql fragment **';

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(17);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _single = __webpack_require__(242);
	
	var _single2 = _interopRequireDefault(_single);
	
	var _seo = __webpack_require__(32);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleSinglePost = function (_Page) {
	  _inherits(ArticleSinglePost, _Page);
	
	  function ArticleSinglePost() {
	    _classCallCheck(this, ArticleSinglePost);
	
	    return _possibleConstructorReturn(this, _Page.apply(this, arguments));
	  }
	
	  ArticleSinglePost.prototype.onMountGlobalState = function onMountGlobalState(state) {
	    return _extends({}, state, {
	      whiteLogo: false
	    });
	  };
	
	  ArticleSinglePost.prototype.render = function render() {
	    return [_react2.default.createElement(_seo2.default, _extends({}, this.props.data.article, this.props.pathContext, {
	      key: 'seo'
	    })), _react2.default.createElement(_single2.default, _extends({
	      data: this.props.data
	    }, this.props.pathContext, {
	      key: 'page'
	    }))];
	  };
	
	  return ArticleSinglePost;
	}(_page2.default);
	
	exports.default = ArticleSinglePost;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-single-js-b3e8aa76b4c46881b104.js